import AppForm from '../app-components/Form/AppForm';

Vue.component('document-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                employee_contract_id:  '' ,
                document_template_id:  '' ,
                
            }
        }
    }

});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/document/Form.js